'use strict';

import reCaptcha from './reCaptcha.js';

var $btnFormSubmit = document.getElementById('js-btn-form-submit');
var $inputName = document.getElementById('name');
var $inputEmail = document.getElementById('email');
var $inputComment = document.getElementById('message');
var $inputPhone = document.getElementById('phone');
var $inputCustomerNo = document.querySelector('input[name="customerNo"]');
const $reCaptchaField = $('.js-recaptcha-token');
const form = document.getElementById('contact-us-form');

// Functions
function validateText(el) {
    if (el.value.length) {
        el.classList.remove('error');
        return true;
    } else {
        el.classList.add('error');
        return false;
    }
}
function validatePhone(el) {
    var res = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im;
    if (res.test(el.value)) {
        el.classList.remove('error');
        return true;
    } else if (!res.test(el.value) || el.value == '') {
        el.classList.add('error');
        return false;
    }
    else if (el.value.length == 0) {
        el.classList.add('error');
        return false;
    }
}
function validateEmail(el) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(el.value)) {
        el.classList.remove('error');
        return true;
    } else {
        el.classList.add('error');
        return false;
    }
}

function validateCaptcha(token) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: $reCaptchaField.data('validate-url'),
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                token: token
            })
        })
        .done((response) => {
            resolve(response); // Resolve the promise with the response
        })
        .fail(() => {
            reject(false); // Reject the promise with false
        });
    });
}

/**
 * Mask sensitive data for console logging
 * Implementation mirrors backend stringHelpers.maskEmail() and stringHelpers.maskPhone()
 * @param {string} value - Value to mask
 * @param {string} type - Type of data (email, phone, customerNo)
 * @returns {string} Masked value
 */
function maskSensitiveData(value, type) {
    if (!value) return null;

    switch (type) {
        case 'email':
            // Pattern matches stringHelpers.maskEmail()
            // user@example.com → u***e@g***l.com
            var emailParts = value.split('@');
            if (emailParts.length === 2) {
                var user = emailParts[0];
                var domainAndExt = emailParts[1].split('.');
                if (domainAndExt.length >= 2) {
                    var domain = domainAndExt[0];
                    var ext = domainAndExt.slice(1).join('.');

                    var maskedUser = user.length > 1
                        ? user[0] + '*'.repeat(user.length - 2) + user[user.length - 1]
                        : user;

                    var maskedDomain = domain.length > 1
                        ? domain[0] + '*'.repeat(domain.length - 2) + domain[domain.length - 1]
                        : domain;

                    return maskedUser + '@' + maskedDomain + '.' + ext;
                }
            }
            return '***';

        case 'phone':
            // Pattern matches stringHelpers.maskPhone()
            // 5035551234 → ***-***-1234
            var cleaned = value.replace(/\D/g, '');
            if (cleaned.length >= 4) {
                return '***-***-' + cleaned.slice(-4);
            }
            return '***';

        case 'customerNo':
            // Similar approach to existing masking
            // 12345678 → ****5678
            if (value.length >= 4) {
                return '****' + value.slice(-4);
            }
            return '***';

        default:
            return '***';
    }
}

function callMeruGetUOOMDetails(email, customerNo) {
    if (
        email &&
        window.meruCookieManager &&
        typeof window.meruCookieManager.getUOOMDetails === 'function'
    ) {
        try {
            var meruParams = {
                email: email
            };

            // Add customer number from form input
            if (customerNo) {
                meruParams.ids = [customerNo];
            }

            // Call Meru API
            window.meruCookieManager.getUOOMDetails(meruParams);

            // Log masked data (only non-empty fields)
            var maskedData = {};
            maskedData.email = maskSensitiveData(email, 'email');
            if (customerNo) {
                maskedData.customerNo = maskSensitiveData(customerNo, 'customerNo');
            }
            console.log('[Meru] Called getUOOMDetails from contact form with:', maskedData);
        } catch (error) {
            console.error('[Meru] Error calling getUOOMDetails:', error);
        }
    }
}

function initEvents() {
    $inputName.addEventListener('blur', function () {
        if (!validateText(this)) {
            this.value = '';
        }
    }, false);

    $inputName.addEventListener('keyup', function () {
        validateText(this);
    }, false);

    $inputPhone.addEventListener('blur', function () {
        if (!validatePhone(this)) {
            this.value = '';
        }
    }, false);

    $inputPhone.addEventListener('keyup', function () {
        validatePhone(this);
    }, false);

    $inputComment.addEventListener('blur', function () {
        if (!validateText(this)) {
            this.value = '';
        }
    }, false);

    $inputComment.addEventListener('keyup', function () {
        validateText(this);
    }, false);

    $inputEmail.addEventListener('blur', function () {
        if (!validateEmail(this)) {
            this.value = '';
        }
    }, false);

    $inputEmail.addEventListener('keyup', function () {
        validateEmail(this);
    }, false);

    $btnFormSubmit.addEventListener('click', async function (e) {
        e.preventDefault();

        try {
            const captchaToken = await reCaptcha.formSubmit();
            if (!captchaToken) {
                return false;
            }

            const validationCaptchaResponse = await validateCaptcha(captchaToken);
            if (
                !validationCaptchaResponse ||
                !validationCaptchaResponse.success
            ) {
                return false;
            }

            if (
                validateText($inputName) &&
                validateText($inputComment) &&
                validateEmail($inputEmail) &&
                validatePhone($inputPhone)
            ) {
                // Call Meru UOOM tracking with email and customerNo from form
                var customerNo = $inputCustomerNo ? $inputCustomerNo.value : null;
                callMeruGetUOOMDetails($inputEmail.value, customerNo);
                
                // all fields valid, submit form
                return form.submit();
            }
            console.log('success');
        } catch (error) {
            console.log(error);
        }
    }, false);
}

export default {
    'init': () => {
        initEvents();
    }
};
